export function saleCreditReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SALE_CREDIT":  
            return {
                [payload.id]: payload,
                ...state
            }

        case "UPDATE_SALE_CREDIT":  
            return {
                ...state,
                [payload.id]: { ...(state[payload.id] || {}), ...payload }
            }
            
        case "GET_SALE_CREDITS":
            return payload
        
        case "DELETE_SALE_CREDIT":
            const { [payload]: deleted, ...newState } = state;
            return newState;

        
        default:
            return state;
    }
    
}